function Carousel({ items }) {
  return (
    <div
      id="carouselTreatments"
      className="carousel slide my-3 d-xxl-none"
      data-bs-ride="carousel"
    >
      <div className="carousel-indicators">
        {items.map((item, i) => (
          <button
            key={i}
            type="button"
            data-bs-target="#carouselTreatments"
            data-bs-slide-to={i}
            className={`bg-palegreen${i===0?" active":""}`}
            aria-label={item.title}
          />
        ))}
      </div>
      <div className="carousel-inner">
        {items.map((item, i) => (
          <div key={i} className={`carousel-item${i===0?" active":""}`} data-bs-interval="10000">
            <div className="col-8 d-flex align-items-start mx-auto">
              <div>
                <h3 className={`fs-2 text-body-emphasis ${item.color}`}>
                  {item.title}
                </h3>
                <p>{item.description}</p>
                <a className={`icon-link ${item.color}`} href={item.href}>
                  Részletek
                  <i className={`bi bi-chevron-right ${item.color}`}></i>
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
      <button
        className="carousel-control-prev mb-5"
        type="button"
        data-bs-target="#carouselTreatments"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon" aria-hidden="true">
          <i className="bi bi-chevron-compact-left palegreen h1"></i>
        </span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button
        className="carousel-control-next mb-5"
        type="button"
        data-bs-target="#carouselTreatments"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon" aria-hidden="true">
          <i className="bi bi-chevron-compact-right palegreen h1"></i>
        </span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
}

export default Carousel;
